export interface ConcurrentUsageDbData {
    key: string;
    payload: string;
    deleted: number;
    timestamp: number;
}

export enum ConcurrentUsageEntryState {
    PRESENT = 0,
    DELETED = 1,
}
